module.exports = __webpack_public_path__ + "static/media/backVideo.728f9b1b.mp4";